import { useDispatch, useSelector } from "react-redux";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { useNavigate } from "react-router-dom";
import { setVideoStart, setVideoSuccess } from "redux/VideoPlayerRedux";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { BsPlayFill } from "react-icons/bs";

function SingleEpisode({ data, id, season, event }: any) {
  const dispatch = useDispatch<any>();
  const { currentVideo } = useSelector((state: any) => state?.video);
  const navigate = useNavigate();

  const isActive = currentVideo?.id === data?.id;

  const episodeOnClick = () => {
    const value = {
      ...data,
    };
    dispatch(setVideoStart());
    dispatch(setVideoSuccess(value));
    navigate("/ppv/replay/" + event?.slug + "/" + data?.stream_key, {
      state: { prevPage: event?.slug },
    });
  };

  return (
    <div
      className={`group my-2.5 flex min-h-[60px] w-full cursor-pointer items-center gap-3 overflow-hidden rounded-xl border bg-white/[0.03] p-2 transition-all duration-300 max-sm:w-full ${
        isActive
          ? "border-[#f30543] bg-white/[0.06]"
          : "border-white/5 hover:border-[#f30543]/40 hover:bg-white/[0.06]"
      }`}
      onClick={episodeOnClick}
    >
      {/* thumbnail */}
      <div className="relative h-[50px] w-[80px] shrink-0 overflow-hidden rounded-md">
        <img
          src={event?.thumbnailImage}
          alt="thumbnail"
          className="h-full w-full object-cover"
        />
        <div
          className={`absolute inset-0 flex items-center justify-center bg-black/40 transition-opacity duration-300 ${
            isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100"
          }`}
        >
          <BsPlayFill
            className={`text-2xl ${isActive ? "text-[#f30543]" : "text-white"}`}
          />
        </div>
      </div>

      {/* details */}
      <div
        className="min-w-0 flex-1"
        data-tooltip-id={
          data?.title?.length > 30 ? `ppv-single-recording-${data?.title}` : ""
        }
      >
        <p
          className={`truncate text-[14px] ${
            isActive ? "font-semibold text-white" : "text-white/70"
          }`}
        >
          {decodeHtmlEntities(data?.title)}
        </p>
        <div className="z-50 text-sm">
          <ReactTooltip
            id={`ppv-single-recording-${data?.title}`}
            place="top"
            content={data?.title}
            style={{ width: "180px", zIndex: 50 }}
          />
        </div>
      </div>
    </div>
  );
}

export default SingleEpisode;
